<script lang="ts">
  import type { HTMLAttributes } from "svelte/elements"

  let props: HTMLAttributes<HTMLSpanElement> = $props()
</script>

<span
  {...props}
  class={[
    "loader",
    "relative box-border block size-[2.5rem] rounded-full",
    "before:absolute before:inset-0 before:rounded-full before:border-[0.25rem] before:border-solid before:border-current",
    props.class,
  ]}
></span>

<style>
  .loader {
    animation: rotate 1s linear infinite;
  }
  .loader::before {
    animation: spinner 2s linear infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes spinner {
    0% {
      clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
    }
    25% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
    }
    50% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
    }
    75% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
    }
    100% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
    }
  }
</style>
